import { createContext, useContext } from "react";
import DEFAULT_CITY from "../constants/defaultCity";

const DefaultCityContext = createContext(DEFAULT_CITY);

export function DefaultCityProvider({ children, city }) {
  return (
    <DefaultCityContext.Provider value={city}>
      {children}
    </DefaultCityContext.Provider>
  );
}

export function useDefaultCity() {
  return useContext(DefaultCityContext);
}
